import { SVGProps } from 'react';

export const ArrowLeft2Icon = ({
  width = '13',
  height = '10',
  stroke = '#202020',
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    fill='none'
    viewBox='0 0 13 10'
    {...props}
  >
    <path
      stroke={stroke}
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.3'
      d='M.65 4.817h11.667m-11.667 0 4.167 4.167M.65 4.817 4.817.65'
    ></path>
  </svg>
);
